export default {
    edit_swap_sim_card_title: "Completar Configuración",
    edit_swap_sim_card_sim_details_error: "No fue posible obtener el detalle de la sim",
    edit_swap_sim_card_saved_successfully: "Guardado con éxito",
    edit_swap_sim_card_the_was_an_error_in_the_save: "Hubo un error mientras se guardaba",
    edit_swap_sim_card_device_imei: "IMEI del dispositivo",
    edit_swap_sim_card_device_esn: "ESN del dispositivo",
    edit_swap_sim_card_sim_provider_account: "Cuenta de proveedor de SIM",
    edit_swap_sim_card_sim_sim_phone: "Teléfono Sim",
    edit_swap_sim_card_load_phone_number: "Cargue el número de teléfono",
    edit_swap_sim_card_iccid_minlength: "El ICCID debe tener entre 14 y 20 caracteres",
}